export default __webpack_public_path__ + "static/orr_protection-c25cdf83e36400e8d0085c6c98e9bbe7.jpg";